import React from "react";

import type { FolderFlag } from "@/lib/leaves/leafRules";

import { FolderHeader } from "./FolderHeader";
import { type Leaf, LeafRow } from "./LeafRow";
import { AREA, LEAF_GRID } from "./leafGrid";

interface LeavesTableProps {
  groups: { folder: string; leaves: Leaf[] }[];
  isOpen: (folder: string) => boolean;
  onToggle: (folder: string) => void;
  onRequiredChange: (leaf: Leaf, next: boolean) => Promise<void>;
  onSetAll: (folder: string, flag: FolderFlag, leaves: Leaf[]) => void;
}

const head = "text-xs font-medium text-slate-500 dark:text-slate-400";

export const LeavesTable: React.FC<LeavesTableProps> = ({
  groups,
  isOpen,
  onToggle,
  onRequiredChange,
  onSetAll,
}) => (
  <div className="text-sm text-slate-900 dark:text-slate-100">
    <div
      className={`${LEAF_GRID} sticky top-16 z-10 h-10 !gap-y-0 content-center rounded-t-lg bg-white shadow-[inset_0_-1px_0_theme(colors.slate.200)] dark:bg-slate-900 dark:shadow-[inset_0_-1px_0_theme(colors.slate.800)]`}
    >
      <span className={`${AREA.leaf} ${head} max-[1399px]:hidden`}>Leaf</span>
      <span className={`${AREA.label} ${head}`}>
        <span className="min-[1400px]:hidden">Leaf and label</span>
        <span className="max-[1399px]:hidden">Label</span>
      </span>
      <span className={`${AREA.type} ${head}`}>Input type</span>
      <span className={`${AREA.req} ${head}`}>Required</span>
      <span className={`${AREA.ps} ${head}`}>Per store</span>
    </div>
    {groups.map(({ folder, leaves }) => {
      const open = isOpen(folder);
      return (
        <section key={folder}>
          <FolderHeader
            folder={folder}
            open={open}
            shown={leaves.length}
            required={leaves.filter((l) => l.alwaysRequired).length}
            perStore={leaves.filter((l) => l.perStore).length}
            onToggle={() => onToggle(folder)}
            onSetAll={(flag) => onSetAll(folder, flag, leaves)}
          />
          {open &&
            leaves.map((leaf) => (
              <LeafRow
                key={leaf.path}
                leaf={leaf}
                onRequiredChange={onRequiredChange}
              />
            ))}
        </section>
      );
    })}
  </div>
);
